import { RequestServerClass } from '../../util/request';
import publishObjectPath from '@/util/configRegistry';

const serverUrl = publishObjectPath.serverUrl;

export class SafetyAndEnvironmentAssessmentServer {
  public rSerivce: any;

  constructor(opt: any, axiosFilterFn?: any) {
    this.rSerivce = new RequestServerClass(opt);
    axiosFilterFn.call(this, this.rSerivce.serverObj);
  }

  // 安环考核
  // 分页查询所有数据
  public getSafetyAndEnvironmentList(opts: object) {
    const url = serverUrl + '/api/yunnan/assessReportHead';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 安环考核
  // 考核-tab列表
  public getAdjusttList(opts: object) {
    const url = serverUrl + '/api/yunnan/assessReportHead/adjust';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 安环考核首页-查看
  // 查询安全环保所有数据
  public getSafetyEnvironmentList(opts: object) {
    const url = serverUrl + '/api/yunnan/assessReportHead/viewSafetyEnvironment';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 安环考核首页-查看
  // 查询按季度所有数据
  public getviewSeasonByQuarterly(opts: object) {
    const url = serverUrl + '/api/yunnan/assessReportHead/viewSeason';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 查询安全生产
  public getSafetyProdList(opts: object) {
    const url = serverUrl + '/api/yunnan/assessReportHead/viewSafetyProd';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 查询环保
  public getProtectList(opts: object) {
    const url = serverUrl + '/api/yunnan/assessReportHead/viewProtect';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 查询责任状
  public getDutyList(opts: object) {
    const url = serverUrl + '/api/yunnan/assessReportHead/viewDuty';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 新增数据
  public addPerformanceData(opts: object) {
    const url = serverUrl + '/api/yunnan/assessReportHead/insert';
    return this.rSerivce.serverObj.post(url, opts);
  }

  // 审核
  public addAuditAssessReportData(opts: object) {
    const url = serverUrl + '/api/yunnan/assessReportHead/auditAssessReport';
    return this.rSerivce.serverObj.post(url, opts);
  }

  // 首页->考核-保存考核奖惩
  public addSavePunishmentsData(opts: object) {
    const url = serverUrl + '/api/yunnan/assessReportHead/savePunishments';
    return this.rSerivce.serverObj.post(url, opts);
  }

  // 考核项目展示列表
  public getAssessStandConfigAll(opts: object) {
    const url = serverUrl + '/api/yunnan/assessStandConfig/all';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 考核项目展示列表
  public getAssessStandConfigNewAll(opts: object) {
    const url = serverUrl + '/api/yunnan/assessStandConfig/getAssessProject';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 被考核部门列表
  public getByDepartments(opts: object) {
    const url = serverUrl + '/api/yunnan/assessDepartmentConfig/getByDepartments';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 新增数据
  public addInnerPerformanceData(opts: object) {
    const url = serverUrl + '/api/yunnan/assessReportHead/insertRecord';
    return this.rSerivce.serverObj.post(url, opts);
  }

  // 新增数据
  public editInnerData(opts: object) {
    const url = serverUrl + '/api/yunnan/assessReportHead/updateRecord';
    return this.rSerivce.serverObj.post(url, opts);
  }
  // 详情
  public getReportViewAllData(id: string) {
    const url = serverUrl + `/api/yunnan/assessReportHead/viewRecords/${id}`;
    return this.rSerivce.serverObj.get(url);
  }

  // 首页->考核-查看考核扣分明细
  public getViewRecordsData(id: string) {
    const url = serverUrl + `/api/yunnan/assessReportHead/${id}`;
    return this.rSerivce.serverObj.get(url);
  }

  // 修改数据
  public editInnerViewDetailsData(opts: object) {
    const url = serverUrl + '/api/yunnan/assessReportHead/updateRecords';
    return this.rSerivce.serverObj.put(url, opts);
  }
}
